// React Imports
import React from 'react';

// Mui Imports
import {Avatar, Link, Tooltip} from '@mui/material';
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange, grey} from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";

// App Imports
import WorkIssuanceStatusMenu from "../Status/WorkIssuanceStatusMenu";


// main function
export const WorkIssuanceFringeGridColumns = ({ expandCdpId, openSourceWindow,  handleClickedRow }) => [
    {
        field: "contractExplore",
        headerName: '',
        width: 30,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: true,
        renderCell: (contracts) => {
            return (
                // renderCell: (cellValues) => {
                //     return (
                //         render: (text, contract) =>
                <Link to={"/ContractDrilldown"}>
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        {/*<MenuBookIcon onClick= {() => handleDrilldown(contracts.row.id, contracts.row.mcode, contracts.row.name, contracts.row.description, contracts.row)}/>*/}
                    </IconButton>
                </Link>

            );
        }
    },
    {
        field: 'id',
        headerName: 'id',
        description: '',
        sortable: true,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'reuseMarket',
        headerName: 'Reuse Market',
        description: '',
        sortable: false,
        editable: true,
        width: 200,
    },
    //
    {
        field: 'cdpId',
        headerName: 'cdpId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'dataPointId',
        headerName: 'dataPointId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'fringeStatus',
        headerName: 'Status',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: false
    },
    {
        field: "more",
        headerName: '',
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: false,
        renderCell: (contractDataPoints) => {
            return (
                // <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>
                <WorkIssuanceStatusMenu/>

            );
        }

    },

    {
        field: 'dataPointName',
        headerName: 'Data Point',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 400,
        hide: false,
        renderCell: (contractDataPoints) => {
            return (
                <Tooltip  enterDelay={1000} enterNextDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                    {"dp id: " + contractDataPoints.row.dataPointId +
                        "\ncdp id: " + contractDataPoints.row.cdpId +
                        "\ncdpv id: " + contractDataPoints.row.cdpvId +
                        "\nhierarchy: " + contractDataPoints.row.hierarchy +
                        "\nhierarchy order: " + contractDataPoints.row.hierarchyOrder +
                        "\nhierarchy level: " + contractDataPoints.row.hierarchyLevel
                        // "\nsource section id: " + workQueueCDP.row.sourceContractSectionId +
                        // "\nsource contract data point id: " + workQueueCDP.row.sourceContractDataPointId
                    }</span>}>
                    <div className="rowitem"
                         onClick= {() => handleClickedRow(contractDataPoints.row)}
                        // onClick= {() => handleExpression(workQueueCDP.row.id,  workQueueCDP.row.contractSectionId, fetchWorkQueueCDP)}
                         style={{cursor:'pointer', backgroundColor: contractDataPoints.row.id === expandCdpId ? 'yellow' : 'transparent',}}
                    >{contractDataPoints.row.dataPointName}</div></Tooltip>)}
    },
    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },

    {
        field: 'dataType',
        headerName: 'dataType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'sourceType',
        headerName: 'sourceType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'dataPointRange',
        headerName: 'Range',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'cdpId',
        headerName: 'CDP ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpvId',
        headerName: 'CDPV ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },

    {
        field: 'value',
        headerName: 'raw value',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },

    {
        field: 'displayValue',
        headerName: 'Value',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 240,
        hide: false
    },

    {
        // field: 'mockIndicator',
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Expression',
        renderCell: (contracts) =>
        {
            if((contracts.row.expression !== null) && (contracts.row.expression !== '')){
                return (
                    <Tooltip title={"Value comes from an expression.  Click to see."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                    </Tooltip>)}
            // if(contracts.row.mockIndicator=='m'){
            //     return (
            //         <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{contracts.row.mockIndicator} </Avatar>)}
        },
        description: '',
        sortable: false,
        width: 90,
    },
    {
        field: 'iterationNumber',
        headerName: '#',
        description: '',
        sortable: false,
        editable: true,
        width: 15,
        hide: false
    },
    {
        field: 'contractName',
        headerName: 'On Contract',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        // editable: true,
        width: 350,
        hide: false
    },

    {
        field: 'sourceContractDataPointId',
        headerName: 'Source',
        description: '',
        renderCell: ({ row }) => {
            if (!row.sourceSection) return <div />;

            // Dynamically collect all non-null parent sections (from 10 to 1)
            const parentSections = [];
            for (let i = 10; i >= 1; i--) {
                const section = row[`sourceParentSection${i}`];
                if (section) parentSections.push(section);
            }

            // Build the full tooltip string
            const tooltipText = `from:\n${row.sourceContractName}\n\nin:\n${parentSections.join('\n')}\n${row.sourceSection}`;

            return (
                <Tooltip placement="right-end" title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipText}</span>}>
                    <Avatar sx={{ height: 20, width: 20, fontSize: 16, bgcolor: grey[500] }}
                            onClick={() => openSourceWindow(row)}
                    >s</Avatar>
                </Tooltip>
            );
        }
    }
    ,

    {
        field: 'hierarchyLevel',
        headerName: 'hierarchyLevel',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchyOrder',
        headerName: 'hierarchyOrder',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchy',
        headerName: 'Hierarchy',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },


];
